"use client";

import React from "react";
import { Facebook, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
const socialLinks = [{
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}];
const servicesLinks = [{
  label: "Airport Transfers",
  to: "#"
}, {
  label: "Executive Travel",
  to: "/CorporatePage"
}, {
  label: "Hourly Chauffeur",
  to: "#"
}, {
  label: "Corporate Accounts",
  to: "/CorporatePage"
}, {
  label: "Private Events",
  to: "#"
}, {
  label: "Wine Country Tours",
  to: "#"
}];
const companyLinks = [{
  label: "About Us",
  to: "#"
}, {
  label: "Our Fleet",
  to: "#"
}, {
  label: "Contact",
  to: "/ReachUsPage"
}];
export default function Footer() {
  return <section data-section-id="166904" id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-primary/10 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 md:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="#" className="inline-block mb-4">
              <span className="text-primary font-serif text-2xl font-bold tracking-tight">
                AAP Luxury Transfers
              </span>
            </Link>
            <p className="text-muted-foreground text-sm font-sans mb-8">
              Private Chauffeur Service · Bay Area
            </p>
            <div className="flex gap-5">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} data-index={i} aria-label={social.label} className="text-muted-foreground hover:text-primary transition-all duration-300 hover:-translate-y-1 hover:drop-shadow-[0_0_10px_var(--color-primary)]">
                    <Icon className="size-5" strokeWidth={1.5} />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="flex flex-col items-start">
            <h3 className="text-primary font-serif text-lg mb-6 tracking-wide uppercase font-semibold">Services</h3>
            <ul className="space-y-3">
              {servicesLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-foreground/70 hover:text-primary transition-colors duration-300 text-sm font-sans">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col items-start">
            <h3 className="text-primary font-serif text-lg mb-6 tracking-wide uppercase font-semibold">Company</h3>
            <ul className="space-y-3">
              {companyLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-foreground/70 hover:text-primary transition-colors duration-300 text-sm font-sans">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col items-start">
            <h3 className="text-primary font-serif text-lg mb-6 tracking-wide uppercase font-semibold">Contact Us</h3>
            <div className="space-y-3 text-foreground/70 text-sm font-sans">
              <p>Available 24/7</p>
              <p className="hover:text-primary transition-colors duration-300">
                dispatch@aapluxurytransfersusa.com
              </p>
              <p>1475 Rollins Rd, Burlingame, CA 94010</p>
            </div>
          </div>

        </div>

        <div className="pt-8 border-t border-primary/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-xs font-sans tracking-widest text-center md:text-left">
            © 2026 AAP Luxury Transfers. All rights reserved. Licensed & Insured · Burlingame, CA
          </p>
          <p className="text-primary/80 text-sm font-serif italic tracking-wider text-center md:text-right">
            The Gold Standard of Travel
          </p>
        </div>
      </div>
    </section>;
}